import { useState } from 'react'
import axios from 'axios'
import { useAuthStore } from '@/modules/auth/stores/authStore'
import { vouchersService } from '../services/vouchersService'
import type { BenefitVoucher } from '../types'

export function useVoucherRedeem() {
  const user = useAuthStore((s) => s.user)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)
  const [redeemedVoucher, setRedeemedVoucher] = useState<BenefitVoucher | null>(null)

  const redeem = async (code: string, product: string, amount: number) => {
    setIsSubmitting(true)
    setError(null)
    setSuccess(false)
    try {
      const userId = user?.userId ?? 0
      const branchId = user?.branchOfficeId ?? 0

      if (!userId || !branchId) {
        setError('No se pudo obtener la información del usuario o sucursal. Inicia sesión nuevamente.')
        return
      }

      const result = await vouchersService.redeem(code, {
        redeemed_by_user_id: userId,
        redeemed_at_branch_id: branchId,
        redeemed_product: product,
        redeemed_amount: amount,
      })
      setRedeemedVoucher(result)
      setSuccess(true)
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al canjear vale')
      } else {
        setError('Error al canjear vale')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const reset = () => {
    setError(null)
    setSuccess(false)
    setRedeemedVoucher(null)
  }

  return { redeem, isSubmitting, error, success, redeemedVoucher, reset }
}
